import { NewTFunction } from 'hooks/useTranslate/useTranslate';

export default function withOptional(
  t: NewTFunction,
  str: string,
  required: boolean,
): string {
  return t(str, { context: !required ? 'optional' : '' });
}
